module.exports = __webpack_public_path__ + "static/media/50007.33a10eda.png";